import "./App.css";
import BgcForm from "./Components/BgcForm";

function App() {
  return (
    <div className="App">
      <BgcForm />
    </div>
  );
}

export default App;
